import { createBlock } from 'factories/block';
import { InteractionProps, repeat } from './interaction';
import { createLayout } from 'factories/layout';
import { colors } from 'styles/variables';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import resultsPassed from 'assets/Correct_loop.gif';
import resultsFailed from 'assets/Incorrect_loop.gif';
import { createMediaBlock } from './media';
import uuid from 'uuidv4';
import { getSId } from '../utils';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import { flatten } from 'factories/utils';

const { lPink } = colors;

const certificateTextField = (isInputField?: boolean) => {
  return createBlock(
    'CertificateTextField',
    [
      createBlock('Text', [], {
        props: {
          isInputField,
          placeholder: isInputField
            ? 'Add placeholder text here...'
            : undefined,
          isCertificateField: true,
        },
      }),
    ],
    {
      props: {
        ...(isInputField && {
          isInputField,
        }),
      },
    }
  );
};

export const createCertificateBlock = () => {
  return createBlock('Certificate', [
    createBlock('CertificateTextFields', [certificateTextField()]),

    createEditableBtn({
      label: 'Download',
    }),
  ]);
};

export const createCertificateTemplatesBlock = () => {
  // these would get their own 'names' (types) maybe. . .
  // just genericized for now
  return createBlock('CertificateTemplates', [
    createBlock('CertificateTemplate', [
      createBlock('Text'),
      createBlock('Text'),
    ]),
    createBlock('CertificateTemplate', [
      createBlock('Text'),
      createBlock('Text'),
    ]),
    createBlock('CertificateTemplate', [
      createBlock('Text'),
      createBlock('Text'),
    ]),
  ]);
};

export const addCertificateTextField = (
  block: Block,
  position: number,
  isInputField: boolean
): [Block, Blocks?] => {
  if (block.type === 'CertificateTextFields') {
    const certificateTextFieldBlock = certificateTextField(isInputField);

    const certificateTextFieldBlockRef = {
      id: certificateTextFieldBlock.id,
      type: 'Ref',
    };
    const [newBlocks] = flatten(certificateTextFieldBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(
      position,
      0,
      certificateTextFieldBlockRef
    );

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeCertificateTextField = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'CertificateTextFields') {
    const certificateTextFieldBlock = certificateTextField();

    const [newBlocks] = flatten(certificateTextFieldBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const createCertificateInteractionBlock = props => {
  const { style } = props as any;

  return createBlock(
    'Interaction',
    [
      createBlock('CertificateMedia', [createMediaBlock({ child: 0 })]),
      createBlock('Certificates', [createCertificateBlock()]),

      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        type: 'Certificate',
        name: props.name,
        sId: getSId('interaction'),

        style: props.style,
      },
      meta: {
        subType: 'Certificate',
        layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
          props.columnsReversed ? 'Reversed' : ''
        }`,
      },
    }
  );
};

export const create = createCertificateInteractionBlock;
export const interactionConfig = {};
